import React, { useRef, useState } from 'react'
import { motion } from 'framer-motion'
import CarouselBanner from '../components/CrauselBanner'
import { Cta } from '../components/Cta';
import { Link } from 'react-router-dom';


const teamMembers = [
    {
        initials: "NK",
        name: "Nikhil Kumar Agrawal",
        designation: "Advocate-on-Record, Patna High Court",
        education: [
            { degree: "LL.M., University College London (UCL)", year: "", badge: "Bentham Scholar" },
            { degree: "B.B.A., LL.B., Symbiosis Law School, Pune", year: "" }
        ],
        specializations: [
            "International Arbitration & Dispute Resolution",
            "Cross-Border Mergers & Acquisitions",
            "Intellectual Property Commercialization",
            "International Business Transactions"
        ],
        panels: [
            // "Retained Counsel, IndiGo Airlines",
            "Bhimrao Ambedkar Bihar University",
            "Bihar State Credit & Investment Corporation Ltd.",
            "Bihar State Financial Corporation"
        ]
    },
    {
        initials: "AH",
        name: "Aditi Hansaria",
        designation: "Advocate-on-Record, Patna High Court",
        education: [
            { degree: "LL.M., London School of Economics (LSE)", year: "", badge: "Marchant Scholar" },
            { degree: "B.L.S., LL.B., Government Law College, Mumbai", year: "" }
        ],
        specializations: [
            "Corporate & Commercial Law",
            "International Commercial Arbitration",
            "Law of Corporate Finance",
            "Corporate Governance & Financial Law"
        ],
        panels: [
            "Member, Bar Council of India",
            "Member, Bihar State Bar Council",
            "Former Assistant Counsel, State of Bihar"
        ]
    }
];
export const Home = () => {
    const highlights = [
        { icon: "⚖", title: "Dispute Resolution", desc: "Litigation & ADR expertise" },
        { icon: "🏛", title: "Real Estate", desc: "Property law & transactions" },
        { icon: "📊", title: "Corporate Law", desc: "Business advisory & compliance" },
        { icon: "📜", title: "Taxation", desc: "Direct & indirect tax matters" },
    ];

    const courts = [
        "Supreme Court of India",
        "High Court of Patna",
        "District & Sessions Courts",
        "NCLT & CLB",
        "Debt Recovery Tribunals",
        "Consumer Redressal Forums",
        "Arbitration Tribunals",
    ];



    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100 } },
    };
    const practiceAreas = [
        {
            id: 1,
            title: "DISPUTE RESOLUTION & LITIGATION",
            description: "Our core practice area covers civil, criminal, and corporate disputes. We represent clients before the Supreme Court of India, High Courts , District Courts, and various tribunals.",
            areas: [
                "Constitutional Law",
                "Criminal Law (Anticipatory Bails, Regular Bails, Quashing)",
                "White-Collar Crimes (CBI & ED)",
                "Corporate & Commercial Disputes",
                "Intellectual Property Law",
                "Service Laws",
                "Consumer Protection",
                "Labour Laws",
                "Land Disputes"
            ],
            icon: "⚖️",
            link: "DisputeResolution"
        },
        {
            id: 2,
            title: "ARBITRATION, MEDIATION & CONCILIATION",
            description: "We assist clients in resolving disputes through Alternative Dispute Resolution (ADR) mechanisms including domestic and , mediation, and conciliation proceedings.",
            areas: [
                "Domestic Arbitration",
                // "International Arbitration",
                "Mediation Proceedings",
                "Conciliation Services"
            ],
            icon: "🤝",
            link: "ArbitrationMediation"
        },
        {
            id: 3,
            title: "REAL ESTATE & PROPERTY LAW",
            description: "Comprehensive property services including title search, due diligence, public notices, title certificates, drafting and negotiating property documents.",
            areas: [
                "Title Search & Due Diligence",
                "Agreement to Sell / Sale Deed",
                "Residential & Commercial Leases",
                "Partition Deeds",
                "Stamp Duty & Registration Advice",
                "Wills And Probate"
            ],
            icon: "🏢",
            link: "RealEstateLaw"
        },
        {
            id: 4,
            title: "CORPORATE & COMMERCIAL LAW",
            description: "Advisory services under Companies Act 2013, Indian Partnership Act, Indian Trust Act, Societies Registration Act, etc.",
            areas: [
                "Company Incorporation",
                "Shareholder Agreements",
                "Joint Ventures",
                "Employment Agreements",
                // "Corporate Restructuring"
            ],
            icon: "💼",
            link: "CorporateCommercialLaw"
        },
        {
            id: 5,
            title: "TAXATION (DIRECT & INDIRECT)",
            description: "Representation before Tax Tribunals and authorities in matters relating to Income Tax, GST, and other direct and indirect tax laws.",
            areas: [
                "Income Tax Matters",
                "GST Advisory & Litigation",
                "Tax Tribunal Representation",
                // "Tax Planning & Compliance"
            ],
            icon: "📊",
            link: "TaxationLaw"
        },
        {
            id: 6,
            title: "BANKING & SECURITIZATION",
            description: "Advisory and litigation services relating to banking laws, SARFAESI Act, Debt Recovery, and representation before Debt Recovery Tribunals (DRTs).",
            areas: [
                "SARFAESI Act Matters",
                "Debt Recovery Proceedings",
                "DRT Representation",
                "Banking Advisory Services"
            ],
            icon: "🏦",
            link: "BankingSecuritization"
        },
        {
            id: 7,
            title: "INTELLECTUAL PROPERTY",
            description: "Protection and enforcement of intellectual property rights including trademarks, copyrights, patents, and related litigation.",
            areas: [
                "Trademark Advisory",
                "Copyright Advisory",
                // "Patent Applications",
                "IP Litigation"
            ],
            icon: "🔒",
            link: "IntellectualPropertyLaw"
        }
    ];
    const clients = [
        { name: "Tata Projects Ltd", category: "Infrastructure & Construction", logo: "T" },
        { name: "McNally Bharat Engineering", category: "Engineering & EPC", logo: "M" },
        { name: "PhonePe", category: "FinTech & Digital Payments", logo: "P" },
        { name: "Hero MotoCorp Ltd", category: "Automobile Manufacturing", logo: "H" },
        { name: "Hindustan Construction Company", category: "Infrastructure & Construction", logo: "HCC" },
        { name: "Phooltas Transrail Ltd", category: "Power Transmission & Rail Infrastructure", logo: "P" },
        { name: "Naturals Dairy Pvt Ltd", category: "Dairy & FMCG", logo: "N" },
        { name: "M/s Aishra Technofab Engineers", category: "Industrial Engineering & Fabrication", logo: "A" },
        { name: "Energy United India Pvt Ltd", category: "Power & Energy Services", logo: "E" },
        { name: "HDFC Bank Ltd", category: "Banking & Financial Services", logo: "HDFC" },
        { name: "Juniper Hotels", category: "Hospitality & Hotels", logo: "J" },
        { name: "M/s GPCL Consulting Services Limited", category: "Engineering Consulting", logo: "G" },
        { name: "Omega Elevators", category: "Vertical Transportation (Elevators)", logo: "Ω" },
        { name: "Adhunik Power and Natural Resources Limited", category: "Power Generation & Natural Resources", logo: "A" },
        { name: "ATC Telecom Infrastructure Private Limited", category: "Telecom Infrastructure", logo: "ATC" },
        { name: "Indus Towers Ltd", category: "Telecom Infrastructure", logo: "I" },
        { name: "Indigo", category: "Aviation (Airlines)", logo: "✈️" },
        { name: "Landmark Outdoor Media Services Pvt. Ltd", category: "Outdoor Advertising & Media", logo: "L" }
    ];

    const industries = Array.from(new Set(clients.map(c => c.category)));

    const containerRef = useRef(null);

    // Enhanced card variants
    const enhancedCardVariants = {
        hidden: { opacity: 0, y: 50, scale: 0.95 },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1]
            }
        },
        hover: {
            y: -8,
            scale: 1.03,
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
            transition: {
                duration: 0.3,
                ease: "easeOut"
            }
        }
    };

    // Enhanced title variants
    const enhancedTitleVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: [0.22, 1, 0.36, 1]
            }
        }
    };

    // Logo animation variants
    const logoVariants = {
        hidden: { scale: 0, rotate: -180 },
        visible: {
            scale: 1,
            rotate: 0,
            transition: {
                type: "spring",
                stiffness: 200,
                damping: 15
            }
        },
        hover: {
            scale: 1.1,
            rotate: 360,
            transition: {
                duration: 0.5,
                ease: "easeInOut"
            }
        }
    };

    // Floating animation for background elements
    const floatVariants = {
        float: {
            y: [0, -10, 0],
            transition: {
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut"
            }
        }
    };

    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3
            }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        },
        hover: {
            y: -10,
            scale: 1.02,
            transition: {
                duration: 0.3,
                ease: "easeInOut"
            }
        }
    };

    const titleVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: "easeOut"
            }
        }
    };

    const lineVariants = {
        hidden: { scaleX: 0 },
        visible: {
            scaleX: 1,
            transition: {
                duration: 1,
                ease: "easeInOut",
                delay: 0.5
            }
        }
    };
    return (
        <>
            <CarouselBanner />

            <section
                id="about"
                style={{
                    backgroundColor: "var(--white)",
                    color: "var(--primary-dark)",
                    padding: "4rem 0",
                }}
            >
                <div className="section-container" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 2rem" }}>
                    {/* Header */}
                    <motion.div
                        className="section-header"
                        style={{ textAlign: "center", marginBottom: "3rem" }}
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 style={{ color: "var(--primary-dark)" }}>About Our Firm</h2>
                        <div
                            className="gold-line"
                            style={{ width: "80px", height: "3px", backgroundColor: "var(--gold)", margin: "1rem auto" }}
                        ></div>
                        <p style={{ color: "var(--gray-dark)", fontSize: "1.1rem" }}>
                            A dedicated team of legal professionals committed to delivering trustworthy and effective legal solutions.
                        </p>
                    </motion.div>

                    {/* Content */}
                    <div className="about-content" style={{ display: "flex", flexWrap: "wrap", gap: "2rem" }}>
                        {/* Text */}
                        <motion.div
                            className="about-text"
                            style={{ flex: "1 1 600px", minWidth: "300px" }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            variants={containerVariants}
                        >
                            <motion.h3
                                style={{ color: "var(--primary-dark)", marginBottom: "1rem" }}
                                variants={itemVariants}
                            >
                                Our Practice
                            </motion.h3>

                            <motion.p style={{ marginBottom: "1rem", color: "var(--primary-dark)" }} variants={itemVariants}>
                                RNA Law Chambers is a distinguished legal practice with extensive experience in representing clients in disputes
                                relating to civil, criminal, and corporate laws. We handle litigation across multiple practice areas including Corporate and Commercial Disputes,
                                Arbitration, Constitutional Law, Criminal Law, White-Collar Crimes, Service Laws, Direct and Indirect Taxation, Intellectual Property, Banking & Securitization Laws,
                                Consumer Protection Laws, Labour Laws, and Land Disputes.
                            </motion.p>

                            <motion.p style={{ marginBottom: "2rem", color: "var(--primary-dark)" }} variants={itemVariants}>
                                Our partners bring international legal education from the London School of Economics and University College London,
                                combined with deep expertise in Indian law and practice. We are committed to providing accessible, efficient, and result-oriented legal solutions
                                while upholding the highest standards of professional ethics and integrity.
                            </motion.p>

                            {/* Highlights */}
                            {/* <motion.div
                                className="about-highlights"
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "1.5rem",
                                    justifyContent: "center",
                                }}
                                variants={containerVariants}
                            >
                                {highlights.map((h, i) => (
                                    <motion.div
                                        key={i}
                                        className="highlight-item"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            backgroundColor: "var(--cream)",
                                            padding: "1rem 1.5rem",
                                            borderRadius: "10px",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                            cursor: "pointer",
                                            minWidth: "280px",
                                            maxWidth: "400px",
                                            flex: "1 1 300px",
                                        }}
                                        variants={itemVariants}
                                        whileHover={{
                                            scale: 1.03,
                                            translateY: -3,
                                            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                                        }}
                                        transition={{ type: "spring", stiffness: 300 }}
                                    >
                                        <div
                                            className="highlight-icon"
                                            style={{
                                                fontSize: "1.2rem",
                                                color: "var(--gold)",
                                                marginRight: "1rem",
                                                flexShrink: 0,
                                            }}
                                        >
                                            {h.icon}
                                        </div>
                                        <div className="highlight-text">
                                            <h5 style={{ color: "var(--primary-dark)", fontFamily: 'fangsong' }}>
                                                {h.title}
                                            </h5>
                                        </div>
                                    </motion.div>
                                ))}
                            </motion.div> */}
                        </motion.div>

                        {/* Image / Court Appearances */}
                        <motion.div
                            className="about-image"
                            style={{ flex: "1 1 400px", minWidth: "300px" }}
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, type: "spring", stiffness: 100 }}
                        >
                            <div className="court-appearances" style={{ backgroundColor: "var(--primary-blue)", padding: "1.5rem", borderRadius: "0.5rem" }}>
                                <h4 style={{ color: "var(--cream)", marginBottom: "1rem" }}>Court Appearances</h4>
                                <motion.div
                                    className="court-list"
                                    style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
                                    variants={containerVariants}
                                >
                                    {courts.map((court, i) => (
                                        <motion.div
                                            key={i}
                                            className="court-item"
                                            style={{
                                                color: "var(--cream)",
                                                backgroundColor: "var(--primary-dark)",
                                                padding: "0.5rem 1rem",
                                                borderRadius: "4px",
                                                fontSize: "0.95rem",
                                                cursor: "pointer",
                                            }}
                                            variants={itemVariants}
                                            whileHover={{ scale: 1.03, backgroundColor: "#ffc107" }}
                                            transition={{ duration: 0.2 }}
                                        >
                                            {court}
                                        </motion.div>
                                    ))}
                                </motion.div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>



            <section
                style={{
                    backgroundColor: "var(--cream)",
                    color: "var(--primary-dark)",
                    padding: "6rem 0",
                    overflow: "hidden"
                }}
                id="practice-areas"
            >
                <div className="container">
                    {/* Section Header */}
                    <motion.div
                        className="row justify-content-center mb-5"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <div className="col-lg-8 col-md-10 text-center">
                            <motion.h2
                                className="display-5 fw-bold mb-3"
                                style={{ color: "var(--primary-blue)" }}
                                variants={titleVariants}
                            >
                                Practice Areas & Services
                            </motion.h2>
                            <motion.div
                                className="d-flex justify-content-center mb-4"
                                variants={lineVariants}
                            >
                                <div style={{
                                    width: "80px",
                                    height: "4px",
                                    backgroundColor: "var(--gold)",
                                    transformOrigin: "left center"
                                }}></div>
                            </motion.div>
                            <motion.p
                                className="lead mb-0"
                                style={{ color: "var(--primary-dark)" }}
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                transition={{ delay: 1, duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                Comprehensive legal services with expertise across multiple domains
                            </motion.p>
                        </div>
                    </motion.div>

                    {/* Practice Areas Grid */}
                    <motion.div
                        className="row g-4"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                    >
                        {practiceAreas.map((area) => (
                            <div className="col-lg-4 col-md-6" key={area.id}>
                                <motion.div
                                    className="h-100"
                                    variants={cardVariants}
                                    whileHover="hover"
                                >
                                    <div
                                        className="card h-100 border-0 shadow-sm overflow-hidden"
                                        style={{
                                            backgroundColor: "var(--white)",
                                            borderRadius: "12px",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        {/* Card Header */}
                                        <div
                                            className="card-header border-0 py-4 px-4 position-relative"
                                            style={{
                                                backgroundColor: "var(--primary-blue)",
                                                color: "var(--cream)",
                                            }}
                                        >
                                            <motion.div
                                                className="position-absolute"
                                                style={{
                                                    top: "-20px",
                                                    right: "-20px",
                                                    fontSize: "4rem",
                                                    opacity: 0.1,
                                                }}
                                                animate={{
                                                    rotate: [0, 360],
                                                }}
                                                transition={{
                                                    duration: 20,
                                                    repeat: Infinity,
                                                    ease: "linear"
                                                }}
                                            >
                                                {area.icon}
                                            </motion.div>

                                            <div className="d-flex align-items-center">
                                                <div
                                                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        backgroundColor: "var(--gold)",
                                                        color: "var(--primary-dark)",
                                                        fontWeight: "bold",
                                                        fontSize: "1.5rem",
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    {area.icon}
                                                </div>
                                                <h4 className="mb-0" style={{ fontSize: "1.1rem", lineHeight: "1.4" }}>
                                                    {area.title}
                                                </h4>
                                            </div>
                                        </div>

                                        {/* Card Body */}
                                        <div className="card-body p-4">
                                            <motion.p
                                                className="mb-4"
                                                style={{
                                                    color: "var(--primary-dark)",
                                                    fontSize: "0.95rem",
                                                    lineHeight: "1.6"
                                                }}
                                                initial={{ opacity: 0 }}
                                                whileInView={{ opacity: 1 }}
                                                transition={{ delay: 0.5 }}
                                                viewport={{ once: true }}
                                            >
                                                {area.description}
                                            </motion.p>

                                            {/* Areas List */}
                                            <div className="mt-4">
                                                <div className="d-flex align-items-center mb-3">
                                                    <div className="me-2" style={{ width: "3px", height: "20px", backgroundColor: "var(--gold)" }}></div>
                                                    <h5 className="mb-0 fw-semibold" style={{
                                                        color: "var(--primary-blue)",
                                                        fontSize: "0.95rem",
                                                        letterSpacing: "0.5px"
                                                    }}>
                                                        Key Practice Areas
                                                    </h5>
                                                </div>

                                                <ul className="list-unstyled mb-0" style={{ paddingLeft: "1.5rem" }}>
                                                    {area.areas.map((item, index) => (
                                                        <motion.li
                                                            key={index}
                                                            className="mb-3"
                                                            initial={{ opacity: 0, x: -20 }}
                                                            whileInView={{ opacity: 1, x: 0 }}
                                                            transition={{ delay: index * 0.1 }}
                                                            viewport={{ once: true }}
                                                        >
                                                            <div className="d-flex align-items-start">
                                                                <div className="position-relative me-3" style={{ marginTop: "0.3rem" }}>
                                                                    <motion.div
                                                                        className="rounded-circle"
                                                                        style={{
                                                                            width: "6px",
                                                                            height: "6px",
                                                                            backgroundColor: "var(--gold)"
                                                                        }}
                                                                        whileHover={{ scale: 1.5 }}
                                                                        transition={{ type: "spring", stiffness: 500 }}
                                                                    ></motion.div>
                                                                </div>
                                                                <span style={{
                                                                    color: "var(--primary-dark)",
                                                                    fontSize: "0.9rem",
                                                                    lineHeight: "1.5"
                                                                }}>
                                                                    {item}
                                                                </span>
                                                            </div>
                                                        </motion.li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>

                                        {/* Card Footer */}
                                        <motion.div
                                            className="card-footer border-0 py-3 px-4"
                                            style={{
                                                backgroundColor: "rgba(var(--primary-blue-rgb), 0.05)",
                                                borderTop: "1px solid rgba(0,0,0,0.05)"
                                            }}
                                            initial={{ opacity: 0 }}
                                            whileInView={{ opacity: 1 }}
                                            transition={{ delay: 0.8 }}
                                            viewport={{ once: true }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                                                    {area.id}/7
                                                </span>
                                                <Link to={area.link}>
                                                    <motion.button
                                                        className="btn btn-sm"
                                                        style={{
                                                            backgroundColor: "transparent",
                                                            color: "var(--primary-blue)",
                                                            border: "1px solid var(--primary-blue)",
                                                            borderRadius: "4px",
                                                            padding: "0.25rem 1rem",
                                                            fontSize: "0.85rem",
                                                            fontWeight: "500"
                                                        }}
                                                        whileHover={{
                                                            backgroundColor: "var(--primary-blue)",
                                                            color: "var(--cream)",
                                                            scale: 1.05
                                                        }}
                                                        whileTap={{ scale: 0.95 }}
                                                        transition={{ type: "spring", stiffness: 400 }}
                                                    >
                                                        Learn More
                                                        <i className="bi bi-arrow-right ms-2"></i>
                                                    </motion.button>
                                                </Link>
                                            </div>
                                        </motion.div>
                                    </div>
                                </motion.div>
                            </div>
                        ))}
                    </motion.div>


                </div>
            </section>


            <section
                style={{
                    backgroundColor: "var(--white)",
                    color: "var(--primary-dark)",
                    padding: "5rem 0",
                }}
            >
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-8 col-md-10 text-center">
                            <h2 className="display-5 fw-bold mb-3" style={{ color: "var(--primary-blue)" }}>
                                Our Team
                            </h2>
                            <div className="d-flex justify-content-center mb-4">
                                <div style={{ width: "60px", height: "3px", backgroundColor: "var(--gold)" }}></div>
                            </div>
                            <p className="lead mb-0" style={{ color: "var(--primary-dark)" }}>
                                Meet our distinguished partners who bring international legal education and extensive courtroom experience.
                            </p>
                        </div>
                    </div>

                    <div className="row justify-content-center g-4">
                        {teamMembers.map((member, index) => (
                            <div className="col-lg-6 col-md-10" key={index}>
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                >
                                    <div
                                        className="card h-100 shadow-sm overflow-hidden"
                                        style={{
                                            transition: "all 0.3s ease",
                                            borderRadius: "8px",
                                            backgroundColor: "var(--white)",
                                            border: '1px solid var(--primary-dark)'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.1)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.boxShadow = "0 2px 10px rgba(0, 0, 0, 0.05)";
                                        }}
                                    >
                                        {/* Card Header */}
                                        <div
                                            className="card-header border-0 py-4 px-4"
                                            style={{
                                                backgroundColor: "var(--primary-blue)",
                                                color: "var(--cream)",
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className="rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: "70px",
                                                        height: "70px",
                                                        backgroundColor: "var(--gold)",
                                                        color: "var(--primary-dark)",
                                                        fontWeight: "bold",
                                                        fontSize: "1.5rem",
                                                        flexShrink: 0,
                                                        marginRight: "1rem",
                                                    }}
                                                >
                                                    {member.initials}
                                                </div>
                                                <div>
                                                    <h4 className="mb-1" style={{ fontSize: "1.3rem" }}>{member.name}</h4>
                                                    <p className="mb-0 opacity-85" style={{ fontSize: "0.9rem" }}>{member.designation}</p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Card Body */}
                                        <div className="card-body p-4">
                                            {/* Education Section */}
                                            <div className="mb-4">
                                                <div className="d-flex align-items-center mb-3">
                                                    <h5 className="mb-0 fw-bold" style={{
                                                        color: "var(--primary-blue)",
                                                        fontSize: "1rem",
                                                        borderBottom: "2px solid var(--gold)",
                                                        paddingBottom: "0.25rem"
                                                    }}>
                                                        Education
                                                    </h5>
                                                </div>
                                                <div className="ps-1">
                                                    {member.education.map((edu, i) => (
                                                        <div key={i} className="mb-3">
                                                            <div className="d-flex align-items-start">
                                                                <div className="me-2 mt-1">
                                                                    <div style={{
                                                                        width: "8px",
                                                                        height: "8px",
                                                                        backgroundColor: "var(--gold)",
                                                                        borderRadius: "50%"
                                                                    }}></div>
                                                                </div>
                                                                <div>
                                                                    <strong className="d-block" style={{ fontSize: "0.95rem" }}>{edu.degree}</strong>
                                                                    <div className="d-flex align-items-center mt-1">
                                                                        <small className="text-muted me-2">{edu.year}</small>
                                                                        {edu.badge && (
                                                                            <span
                                                                                className="badge"
                                                                                style={{
                                                                                    backgroundColor: "var(--gold)",
                                                                                    color: "var(--primary-dark)",
                                                                                    fontSize: "0.7rem",
                                                                                    padding: "0.2rem 0.6rem",
                                                                                    borderRadius: "3px",
                                                                                }}
                                                                            >
                                                                                {edu.badge}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Specializations Section */}
                                            {/* <div className="mb-4">
                                                <div className="d-flex align-items-center mb-3">
                                                    <h5 className="mb-0 fw-bold" style={{
                                                        color: "var(--primary-blue)",
                                                        fontSize: "1rem",
                                                        borderBottom: "2px solid var(--gold)",
                                                        paddingBottom: "0.25rem"
                                                    }}>
                                                        Specializations
                                                    </h5>
                                                </div>
                                                <div className="ps-1">
                                                    {member.specializations.map((spec, i) => (
                                                        <div key={i} className="mb-2 d-flex align-items-start">
                                                            <i className="bi bi-dot me-2" style={{
                                                                color: "var(--gold)",
                                                                fontSize: "1.2rem",
                                                                lineHeight: "1.2"
                                                            }}></i>
                                                            <span style={{
                                                                color: "var(--primary-dark)",
                                                                lineHeight: "1.4",
                                                                fontSize: "0.9rem"
                                                            }}>
                                                                {spec}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div> */}

                                            {/* Panels Section */}
                                            <div>
                                                <div className="d-flex align-items-center mb-3">
                                                    <h5 className="mb-0 fw-bold" style={{
                                                        color: "var(--primary-blue)",
                                                        fontSize: "1rem",
                                                        borderBottom: "2px solid var(--gold)",
                                                        paddingBottom: "0.25rem"
                                                    }}>
                                                     Empanelments
                                                    </h5>
                                                </div>
                                                <div className="ps-1">
                                                    {member.panels.map((panel, i) => (
                                                        <div key={i} className="mb-2 d-flex align-items-start">
                                                            <i className="bi bi-dot me-2" style={{
                                                                color: "var(--gold)",
                                                                fontSize: "1.2rem",
                                                                lineHeight: "1.2"
                                                            }}></i>
                                                            <span style={{
                                                                color: "var(--primary-dark)",
                                                                lineHeight: "1.4",
                                                                fontSize: "0.9rem"
                                                            }}>
                                                                {panel}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section
                style={{
                    backgroundColor: "var(--cream)",
                    color: "var(--primary-dark)",
                    padding: "6rem 0",
                    position: "relative",
                    overflow: "hidden"
                }}
            >
                {/* Background decorative elements */}
                <motion.div
                    className="position-absolute"
                    style={{
                        top: "10%",
                        left: "5%",
                        width: "300px",
                        height: "300px",
                        borderRadius: "50%",
                        background: "radial-gradient(circle, rgba(var(--primary-blue-rgb), 0.05) 0%, transparent 70%)",
                        zIndex: 0
                    }}
                    variants={floatVariants}
                    animate="float"
                />

                <motion.div
                    className="position-absolute"
                    style={{
                        bottom: "10%",
                        right: "5%",
                        width: "400px",
                        height: "400px",
                        borderRadius: "50%",
                        background: "radial-gradient(circle, rgba(var(--gold-rgb), 0.05) 0%, transparent 70%)",
                        zIndex: 0
                    }}
                    variants={floatVariants}
                    animate="float"
                    transition={{ delay: 1 }}
                />

                <div className="container position-relative z-1">
                    {/* Section Header */}
                    <motion.div
                        className="row justify-content-center mb-5"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <div className="col-lg-10 text-center">
                            <motion.h2
                                className="display-4 fw-bold mb-3"
                                style={{
                                    color: "var(--primary-blue)",
                                    background: "linear-gradient(135deg, var(--primary-blue) 0%, #2c5282 100%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent"
                                }}
                                variants={enhancedTitleVariants}
                            >
                                Our Esteemed Clients
                            </motion.h2>

                            <motion.div
                                className="d-flex justify-content-center mb-4"
                                initial={{ scaleX: 0 }}
                                whileInView={{ scaleX: 1 }}
                                transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
                                viewport={{ once: true }}
                            >
                                <div style={{
                                    width: "100px",
                                    height: "4px",
                                    background: "linear-gradient(90deg, transparent, var(--gold), transparent)",
                                    borderRadius: "2px"
                                }}></div>
                            </motion.div>

                            <motion.p
                                className="lead mb-4"
                                style={{
                                    color: "var(--primary-dark)",
                                    maxWidth: "600px",
                                    margin: "0 auto"
                                }}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.8, duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                Trusted by leading organizations across industries worldwide
                            </motion.p>
                        </div>
                    </motion.div>

                    {/* Marquee Section - Square Cards */}
                    <div className="position-relative overflow-hidden">
                        {/* Gradient Fades */}
                        <div
                            className="position-absolute start-0 top-0 h-100 z-3"
                            style={{
                                width: "100px",
                                background: "linear-gradient(90deg, var(--cream) 0%, transparent 100%)",
                                pointerEvents: "none"
                            }}
                        />
                        <div
                            className="position-absolute end-0 top-0 h-100 z-3"
                            style={{
                                width: "100px",
                                background: "linear-gradient(90deg, transparent 0%, var(--cream) 100%)",
                                pointerEvents: "none"
                            }}
                        />

                        {/* Single Marquee Row - Square Cards */}
                        <motion.div
                            className="d-flex"
                            animate={{
                                x: [0, -2000],
                            }}
                            transition={{
                                x: {
                                    repeat: Infinity,
                                    duration: 40,
                                    ease: "linear"
                                }
                            }}
                        >
                            {[...clients, ...clients, ...clients].map((client, index) => (
                                <motion.div
                                    key={`card-${client.id}-${index}`}
                                    className="flex-shrink-0 mx-3"
                                    style={{
                                        width: "200px",
                                        height: "200px"
                                    }}
                                    whileHover={{
                                        scale: 1.05,
                                        transition: { duration: 0.2 }
                                    }}
                                >
                                    <div
                                        className="h-100 d-flex flex-column align-items-center justify-content-center p-4"
                                        style={{
                                            backgroundColor: "var(--white)",
                                            borderRadius: "12px",
                                            border: "1px solid rgba(var(--primary-blue-rgb), 0.1)",
                                            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.08)",
                                            transition: "all 0.3s ease"
                                        }}
                                    >
                                        {/* Logo Container */}
                                        <div
                                            className="d-flex align-items-center justify-content-center mb-4"
                                            style={{
                                                width: "80px",
                                                height: "80px",
                                                backgroundColor: index % 3 === 0
                                                    ? "rgba(var(--gold-rgb), 0.1)"
                                                    : index % 3 === 1
                                                        ? "rgba(var(--primary-blue-rgb), 0.1)"
                                                        : "rgba(184, 134, 11, 0.05)",
                                                borderRadius: "8px",
                                                border: `1px solid ${index % 3 === 0
                                                    ? "rgba(var(--gold-rgb), 0.2)"
                                                    : index % 3 === 1
                                                        ? "rgba(var(--primary-blue-rgb), 0.2)"
                                                        : "rgba(184, 134, 11, 0.1)"
                                                    }`
                                            }}
                                        >
                                            <div
                                                className="d-flex align-items-center justify-content-center fw-bold"
                                                style={{
                                                    color: index % 3 === 0
                                                        ? "var(--gold)"
                                                        : index % 3 === 1
                                                            ? "var(--primary-blue)"
                                                            : "var(--primary-dark)",
                                                    fontSize: "1.2rem"
                                                }}
                                            >
                                                {client.logo}
                                            </div>
                                        </div>

                                        {/* Client Name */}
                                        <h6
                                            className="fw-bold mb-0 text-center"
                                            style={{
                                                color: "var(--primary-dark)",
                                                fontSize: "0.8rem",
                                                lineHeight: "1"
                                            }}
                                        >
                                            {client.name}
                                        </h6>

                                        {/* Optional Subtle Category */}
                                        <small
                                            className="text-muted mt-1 text-center"
                                            style={{ fontSize: "0.6rem" }}
                                        >
                                            {client.category}
                                        </small>
                                    </div>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>

                    {/* Stats Section */}
                    {/* <motion.div
                        className="row mt-6 pt-5"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                        viewport={{ once: true }}
                    >
                        <div className="col-12">
                            <div
                                className="p-5 rounded-4"
                                style={{
                                    background: "linear-gradient(135deg, var(--primary-blue) 0%, #1a365d 100%)",
                                    color: "var(--cream)",
                                    position: "relative",
                                    overflow: "hidden"
                                }}
                            >
                                <div className="row text-center">
                                    <motion.div
                                        className="col-md-4 mb-4 mb-md-0"
                                        whileHover={{ scale: 1.05 }}
                                        transition={{ type: "spring", stiffness: 300 }}
                                    >
                                        <h1 className="display-3 fw-bold mb-2">{clients.length * 2}+</h1>
                                        <p className="mb-0 opacity-85">Global Clients</p>
                                    </motion.div>
                                    <motion.div
                                        className="col-md-4 mb-4 mb-md-0"
                                        whileHover={{ scale: 1.05 }}
                                        transition={{ type: "spring", stiffness: 300, delay: 0.1 }}
                                    >
                                        <h1 className="display-3 fw-bold mb-2">18+</h1>
                                        <p className="mb-0 opacity-85">Years Experience</p>
                                    </motion.div>
                                    <motion.div
                                        className="col-md-4"
                                        whileHover={{ scale: 1.05 }}
                                        transition={{ type: "spring", stiffness: 300, delay: 0.2 }}
                                    >
                                        <h1 className="display-3 fw-bold mb-2">98%</h1>
                                        <p className="mb-0 opacity-85">Retention Rate</p>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </motion.div> */}



                </div>
            </section>
            <div className="my-5">
                <Cta
                    Title="Ready for a Consultation?"
                    description="Schedule a consultation and get expert guidance tailored to your needs."
                />

            </div>
        </>
    )
}
